module.exports = __webpack_public_path__ + "img/manutd1.2fb23f81.jpg";